export { default } from './AppBar';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/AppBar/index.js
// module id = 304
// module chunks = 0